import work1 from "../../assets/work1.png"
import work2 from "../../assets/work2.png"
import work3 from "../../assets/work3.png"
import work4 from "../../assets/work4.png"
import work5 from "../../assets/work5.jpg"
import work6 from "../../assets/work6.png"
import workgrab from "../../assets/work-grab.png"
import workdb from "../../assets/work-db.png"

export const projectsData = [
    {
        id: 1,
        image: work6,
        title: "iHatePlanning",
        subtitle: "A full stack planner for the unorganized.",
        category: "Personal",
        link: "https://i-hate-planning-frontend.vercel.app",
        repo: "https://github.com/AviN27/iHatePlanning-frontend",
        techStack: ["Next.js", "MongoDB", "Express.js", "HTML/CSS3", "Supabase"]
    },

    {
        id: 2,
        image: workgrab,
        title: "AgenticWeb",
        subtitle: "A Platform that powers multi-domain agentic automation through LLM-driven reasoning and intelligent orchestration.",
        category: "Personal",
        repo: "https://github.com/AviN27/AgenticWeb",
        techStack: ["Python", "Gemini API", "Embeddings", "Pinecone", "Docker", "Kafka", "Redis", "Langchain", " Asyncio", "FastAPI"]
    },
    
    {
        id: 3,
        image: work2,
        title: "RecipeDB",
        subtitle: "Random recipe generator.",
        category: "Personal",
        link: "https://avin27.github.io/recipeDB/",
        repo: "https://github.com/AviN27/recipeDB",
        techStack: ["React", "TailwindCSS", "JavaScript", "HTML5", "MealDB API"]
    },

    {
        id: 4,
        image: workdb,
        title: "DB Communicator",
        subtitle: "Q&A chatbot with RAG to communicate with your database.",
        category: "Personal",
        repo: "https://github.com/AviN27/DB-Communicator",
        techStack: ["Python", "Gradio", "LangChain", "SQL", "Gemini API", "Langchain"]
    },
    
    {
        id: 5,
        image: work1,
        title: "Another Todo App",
        subtitle: "To-do list creator with voice recognition.",
        category: "Personal",
        link: "https://avin27.github.io/another-todo-app/",
        repo: "https://github.com/AviN27/another-todo-app",
        techStack: ["Vue.js", "Vite", "JavaScript", "HTML/CSS3", "Web Speech API"]
    },

    {
        id: 6,
        image: work3,
        title: "Mobile Application - MedTab",
        subtitle: "Android application for medication tracking.",
        category: "Academic",
        link: "https://www.google.com/",
        techStack: ["Java", "Android Studio", "XML", "SQLite", "Android SDK"]
    }   
]

export const projectsNav = [
    {
        name: "All"
    },

    {
        name: "Academic"
    },

    {
        name: "Personal"
    }
]